import styled from 'styled-components';
import { margin, padding, pxToRem } from '../../styles/mixins';

interface Props {
	$isActive: boolean;
}

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	background-color: var(--gray-100);
	border: 1px solid var(--ins-blue);
	border-radius: 0 0 8px 8px;
	min-height: 500px;
	max-height: 600px;
`;

export const HeadTabOffers = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: flex-start;
	${margin(0, 0, 20, 0)};
	background-color: var(--white);
`;

export const TitleOffers = styled.button<Props>`
	${margin(0, 3)}
	max-width: 360px;
	width: 100%;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ $isActive }) =>
		$isActive ? 'var(--gray-100)' : 'var(--gray-50)'};
	color: var(--black);
	border: none;
	border-bottom: ${({ $isActive }) =>
		$isActive ? '2px solid var(--ins-blue)' : ''};
	border-radius: 8px 8px 0 0;
	font-weight: ${({ $isActive }) => ($isActive ? '600' : '400')};
	${pxToRem(16)};
	transition: 0.2s;
	cursor: pointer;

	&:hover {
		background-color: var(--gray-100);
		font-weight: 600;
	}

	
	@media screen and (max-width: 1024px) {
		max-width: fit-content;
		${padding(0, 15)};
	}
`;

export const ContentOffersList = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	${padding(0, 10, 20, 16)};
	width: 100%;
	height: 100%;
`;

export const OffersUL = styled.ul`
	width: 100%;
	height: 505px;
	list-style: none;
	overflow-y: auto;
	${padding(0, 10, 0, 0)};
	&::-webkit-scrollbar {
		height: 7px;
		width: 7px;
	}
	&::-webkit-scrollbar-track {
		border-radius: 0px;
		background-color: var(--gray-100);
	}

	&::-webkit-scrollbar-track:hover {
		background-color: var(--gray-100);
	}

	&::-webkit-scrollbar-track:active {
		background-color: var(--gray-100);
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #d9d9d9;
	}

	&::-webkit-scrollbar-thumb:hover {
		background-color: #d9d9d9;
	}

	&::-webkit-scrollbar-thumb:active {
		background-color: #d9d9d9;
	}
`;

export const OfferItemList = styled.li`
	width: 100%;
	height: 90px;
	min-height: 90px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 8px;
	${padding(15, 30)};
	background-color: var(--white);

	& + li {
		${margin(13, 0, 0)};
	}

	@media screen and (max-width: 1024px) {
		height: 200px;
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const ContentImage = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TitleImage = styled.h3`
	${pxToRem(16)};
	font-weight: 700;
	color: var(--gray-900);
`;
export const Images = styled.div`
	display: flex;
	align-items: center;

	svg {
		width: 40px;
		height: 40px;

		& + svg {
			margin-left: 60px;
		}
	}
`;

export const ContentInfos = styled.div`
	display: flex;
	flex-direction: column;
	width: 240px;
`;

export const NameCertificate = styled.h4`
	${pxToRem(14)};
	font-weight: 900;
	color: var(--gray-600);
	min-height: 20px;
	max-height: 40px;
	white-space: pre-wrap;
`;

export const MidiaType = styled.p`
	${pxToRem(14)};
	font-weight: 400;
	text-transform: capitalize;
	color: var(--gray-600);
`;

export const CertificateDuration = styled.p`
	${pxToRem(14)};
	font-weight: 400;
	color: var(--gray-600);

	span {
		color: var(--ins-blue);
		font-weight: 700;
	}
`;

export const ContentPrice = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 230px;
`;

export const Price = styled.p`
	${pxToRem(16)};
	color: var(--ins-blue);
	font-weight: 700;

	strong {
		margin-left: 30px;
		${pxToRem(22)};
		font-weight: 900;
	}
`;
export const ButtonBuy = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 207px;
	height: 32px;
	border:none;
	background-color: var(--ins-blue);
	border-radius: 8px;
	${pxToRem(14)};
	font-weight: 700;
	color: var(--white);

	&:hover {
		background-color:#583eff;
	}
`;
